var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaltaLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(23 34)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.383,
    cy: 27.524,
    fill: "#00C861",
    rx: 14.617,
    ry: 14.592
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 101,
    r: 101,
    fill: "#00C861"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.174,
    cy: 135.14,
    fill: "#002094",
    rx: 41.039,
    ry: 40.971
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.184,
    cy: 141.618,
    fill: "#002094",
    rx: 6.184,
    ry: 6.174
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.822,
    cy: 159.835,
    fill: "#FFF",
    rx: 10.119,
    ry: 10.102
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.009,
    cy: 61.618,
    fill: "#002094",
    rx: 24.173,
    ry: 24.133
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M162.757 80.974a28.972 28.972 0 0 0-6.466.571v-1.072h-4.768v-7.069H98.26v7.073l-4.833.01v1.16c-11.537-2.275-18.87 2.01-23.045 5.348v-13.21H39.068v57.872h42.161c9.012 2 17.499-.654 22.962-5.01 3.907 3.343 8.942 5.04 14.972 5.04h15.163v-.879c2.146.585 4.45.88 6.886.88h14.848a.104.104 0 0 0 .034 0c1.851.422 3.784.646 5.782.646 14.632-.006 26.176-10.378 26.168-25.591-.008-14.604-10.557-25.466-25.287-25.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00C861",
    d: "M161.885 84.059c-3.063 0-5.984.585-8.657 1.642v-2.16h-4.768v-7.069h-47.138v7.067l-4.833.01v2.15c-2.4-.816-5.977-1.719-9.294-1.64-8.454.2-15.851 4.45-19.875 11.085v-18.29H42.13v51.735h36.563v-.91a23.497 23.497 0 0 0 8.5 1.581c6.78 0 12.878-2.46 17.102-6.853a15.014 15.014 0 0 0 1.586 1.648c3.38 3.03 7.85 4.565 13.28 4.565h12.1v-2.288c2.874 1.521 6.205 2.288 9.949 2.288h12.014v-1.004a23.462 23.462 0 0 0 8.657 1.642c12.755 0 23.097-8.71 23.097-22.6.003-13.816-10.338-22.6-23.093-22.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002094",
    d: "M163.638 88.639c-5.917-.535-12.13 2.083-14.878 5.256v-5.853h-5.268c.316-1.04.475-2.175.475-3.402v-3.666h-16.102v3.666c0 2.433-.399 3.217-.512 3.387-.04.008-5.912.015-5.912.015.316-1.04.475-2.175.475-3.402v-3.666h-16.102v3.666c0 2.433-.399 3.217-.511 3.387-.04.008-4.324.015-4.324.015v5.865c-1.206-1.231-5.83-5.566-13.763-5.268-15.458.58-19.261 13.613-17.68 21.626h-6.71V81.354H46.621v42.735h27.58v-4.585c1.182 1.193 5.4 5.176 13.317 5.176 11.469 0 16.222-7.906 17.506-12.067.446 3.49 1.734 6.2 3.85 8.084 2.532 2.27 5.993 3.421 10.288 3.421h7.61V109.3h.125s-.421 7.62 4.034 11.402c2.6 2.208 6.01 3.416 10.28 3.416h7.61v-4.59c1.173 1.18 5.199 5.15 13.856 5.15 6.042 0 17.811-3.86 17.811-18.415 0-7.038-4.327-16.49-16.85-17.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M140.492 111.737c-.328-.31-.494-.969-.494-1.896V99.785h5.758v-8.738h-8.515v-.227c2.2-.803 3.722-2.845 3.722-6.182v-.66h-10.099v.66c0 4.43-1.152 6.41-3.722 6.41h-1.09v8.737h3.847v9.91c0 4.019 1.028 6.987 3.024 8.76 1.996 1.771 4.772 2.658 8.288 2.658h4.608v-8.88h-3.434c-.906 0-1.565-.186-1.893-.496ZM59.825 84.361H49.623v36.72h21.576v-7.81H59.825V84.36Zm58.618 27.376c-.328-.31-.494-.969-.494-1.896V99.785h5.758v-8.738h-8.515v-.227c2.2-.803 3.722-2.845 3.722-6.182v-.66h-10.099v.66c0 4.43-1.152 6.41-3.722 6.41h-1.11v8.737h3.867v9.91c0 4.019 1.028 6.987 3.024 8.76 1.975 1.771 4.772 2.658 8.288 2.658h4.608v-8.88h-3.434c-.927 0-1.565-.186-1.893-.496Zm-17.556-13.042c-1.337-2.263-3.161-4.003-5.474-5.222-2.31-1.218-4.926-1.827-7.845-1.827-2.92 0-5.536.61-7.846 1.827a13.624 13.624 0 0 0-5.474 5.222c-1.338 2.263-2.008 4.909-2.008 7.939 0 3.064.66 5.726 1.983 7.99a13.443 13.443 0 0 0 5.447 5.222c2.31 1.22 4.927 1.827 7.846 1.827 2.92 0 5.543-.608 7.87-1.827 2.328-1.218 4.162-2.969 5.5-5.249 1.337-2.28 2.007-4.936 2.007-7.963.002-3.03-.668-5.676-2.006-7.939Zm-9.8 12.507c-.955 1.063-2.146 1.592-3.57 1.592s-2.588-.521-3.493-1.567c-.904-1.044-1.356-2.577-1.356-4.595 0-1.984.47-3.498 1.408-4.544.939-1.046 2.102-1.567 3.493-1.567 1.39 0 2.563.521 3.519 1.567.956 1.044 1.433 2.56 1.433 4.544 0 1.984-.477 3.51-1.433 4.57Zm84.392-12.507c-1.337-2.263-3.161-4.003-5.474-5.222-2.31-1.218-4.926-1.827-7.845-1.827-2.92 0-5.536.61-7.846 1.827a13.624 13.624 0 0 0-5.474 5.222c-1.338 2.263-2.008 4.909-2.008 7.939 0 3.064.66 5.726 1.983 7.99a13.443 13.443 0 0 0 5.447 5.222c2.31 1.22 4.927 1.827 7.846 1.827 2.92 0 5.543-.608 7.87-1.827 2.328-1.218 4.162-2.969 5.5-5.249 1.337-2.28 2.007-4.936 2.007-7.963.002-3.03-.668-5.676-2.006-7.939Zm-9.8 12.507c-.955 1.063-2.146 1.592-3.57 1.592s-2.588-.521-3.493-1.567c-.904-1.044-1.356-2.577-1.356-4.595 0-1.984.47-3.498 1.408-4.544.939-1.046 2.103-1.567 3.493-1.567 1.39 0 2.563.521 3.519 1.567.956 1.044 1.433 2.56 1.433 4.544 0 1.984-.477 3.51-1.433 4.57Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaltaLotto);
export default __webpack_public_path__ + "static/media/malta_lotto.921b2235a065110bd64cef76d9263ed0.svg";
export { ForwardRef as ReactComponent };